import storageInfo from "@/config/naverObjectStroage";
import axios from "axios";
import Promise from "bluebird";
import store from "@/store/";
import { getToken } from "@/utill/auth";
const AWS = require("aws-sdk");

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  auth: {
    username: "client_web_test",
    password: "$2a$10$v64ahSnZvPTLdps.AjaHEOSPKyBWIv915UPyManIR2l1kaRXxSo2m",
  },
});

// request interceptor
instance.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers["X-TRAN-ID"] = token;
  }
  return config;
});

// response interceptor
instance.interceptors.response.use(
  (response) => {
    console.log(`response interceptor response => ${response.data.code}`);
    if (response.data.code !== "00000" || response.data.status !== "OK") {
      if (response.data.code === "90010") {
        console.log("Token expired");
        store.dispatch("resetToken").then(() => {
          window.location.reload();
        });
      } else if (response.data.code === "403" || response.data.code === "202") {
        return response;
      } else {
        return Promise.reject(new Error(response.data.message || "Error"));
      }
    } else {
      return response;
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const get = function (url, params) {
  const config = {
    headers: { Pragma: "no-cache" },
  };
  let promise = new Promise(function (resolve, reject) {
    let response = "";

    if (params) {
      config.params = params.params;
    }
    response = instance.get(url, config);

    if (response) {
      resolve(response);
    } else {
      reject(new Error());
    }
  });

  promise
    .then((response) => {
      console.log(response);
      //goErrorPage(response);
    })
    .catch((error) => {
      console.log(error);
      //goLoginPage(error);
    });

  return promise;
};

export const create = function (url, obj) {
  let promise = new Promise(function (resolve, reject) {
    let response = instance.post(url, obj);

    if (response) {
      resolve(response);
    } else {
      reject(new Error());
    }
  });

  promise
    .then((response) => {
      goErrorPage(response);
    })
    .catch((error) => {
      goLoginPage(error);
    });

  return promise;
};

export const update = function (url, obj) {
  let promise = new Promise(function (resolve, reject) {
    let response = instance.put(url, obj);

    if (response) {
      resolve(response);
    } else {
      reject(new Error());
    }
  });

  promise
    .then((response) => {
      goErrorPage(response);
    })
    .catch((error) => {
      goLoginPage(error);
    });

  return promise;
};

export const remove = function (url, obj) {
  let promise = new Promise(function (resolve, reject) {
    let response = instance.delete(url, { data: obj });

    if (response) {
      resolve(response);
    } else {
      reject(new Error());
    }
  });

  promise
    .then((response) => {
      goErrorPage(response);
    })
    .catch((error) => {
      goLoginPage(error);
    });

  return promise;
};

export const goErrorPage = function (response) {
  let code = response.data.code;
  let result = response.data.result;

  if (code === 204) {
    console.log("204 에러");
  } else if (code === 400) {
    console.log("400 에러");
  } else if (code === 401) {
    if (!result) {
      window.location.href = "/login";
    }
  } else if (code === 403) {
    window.location.href = "/error403";
  } else if (code === 404) {
    window.location.href = "/error404";
  } else if (code === 405) {
    console.log("405 에러");
  } else if (code === 500) {
    window.location.href = "/error500";
  } else if (code === 503) {
    window.location.href = "/error503";
  }
};

export const goLoginPage = function (error) {
  if (error.message === "Network Error") {
    window.location.href = "/login";
  } else {
    console.log(error.message);
  }
};

const S3 = new AWS.S3({
  endpoint: storageInfo.endpoint,
  region: storageInfo.region,
  credentials: {
    accessKeyId: storageInfo.access_key,
    secretAccessKey: storageInfo.secret_key,
  },
});

export const getFilelist = async function () {
  // List All Objects
  let fileList = [];
  const bucket_name = `ubidtx01`;
  const MAX_KEYS = 99999;
  var params = {
    Bucket: bucket_name,
    MaxKeys: MAX_KEYS,
  };
  console.log(`List All In The Bucket`);
  console.log(`==========================`);

  let flag1 = true;
  while (flag1) {
    let response = await S3.listObjectsV2(params).promise();
    console.log(response);
    console.log(`IsTruncated = ${response.IsTruncated}`);
    console.log(`Marker = ${response.Marker ? response.Marker : null}`);
    console.log(
      `NextMarker = ${response.NextMarker ? response.NextMarker : null}`
    );
    console.log(`  Object Lists`);
    for (let content of response.Contents) {
      console.log(
        `    Name = ${content.Key}, Size = ${content.Size}, Owner = ${content.Owner}`
      );
      fileList.push(content);
    }

    if (response.IsTruncated) {
      params.Marker = response.NextMarker;
    } else {
      flag1 = false;
    }
    return fileList;
  }

  // List Top Level Folder And Files
  /*params.Delimiter = "/";
  console.log("Top Level Folders And Files In The Bucket");
  console.log("==========================");

  let flag2 = true;
  while (flag2) {
    let response = await S3.listObjectsV2(params).promise();
    console.log(response);
    console.log(`IsTruncated = ${response.IsTruncated}`);
    console.log(`Marker = ${response.Marker ? response.Marker : null}`);
    console.log(
      `NextMarker = ${response.NextMarker ? response.NextMarker : null}`
    );

    console.log(`  Folder Lists`);
    for (let folder of response.CommonPrefixes) {
      console.log(`Name = ${folder.Prefix}`);
    }

    console.log(`  File Lists`);
    for (let content of response.Contents) {
      console.log(
        `    Name = ${content.Key}, Size = ${content.Size}, Owner = ${content.Owner}`
      );
    }

    if (response.IsTruncated) {
      params.Marker = response.NextMarker;
    } else {
      flag2 = false;
    }
  }*/
};

export const upload = async function (params, callback1, callback2) {
  if (params.Key != null) {
    params.Key = storageInfo.root_folder + params.Key;
  }
  let requestParams = {
    ...params,
    Bucket: storageInfo.bucket_name,
    "Access-Control-Allow-Credentials": "*",
    ACL: "public-read",
  };
  await S3.upload(requestParams, {}, callback1).on(
    "httpUploadProgress",
    callback2
  );
};

export const deleteFile = async function (object_name) {
  (async () => {
    // Delete File
    await S3.deleteObject({
      Bucket: storageInfo.bucket_name,
      Key: object_name,
    }).promise();
  })();
};

export const putBucketCors = async function () {
  let params = {
    Bucket: "ubidtx01",
    CORSConfiguration: {
      CORSRules: [
        {
          AllowedHeaders: ["*"],
          AllowedMethods: ["HEAD", "GET", "PUT", "POST", "DELETE"],
          AllowedOrigins: ["*"],
          ExposeHeaders: ["ETag", "x-amz-meta-custom-header"],
          MaxAgeSeconds: 3000,
        },
      ],
    },
    ContentMD5: "",
  };
  S3.putBucketCors(params, function (err, data) {
    if (err) console.log(err, err.stack);
    // an error occurred
    else console.log(data); // successful response
  });
};

export const createQueryParameters = (parametersObject) => {
  const obj = new Object(parametersObject); // 이거 안 써도 되는데 자바스크립트가 타입이 없다 보니 파라미터의 타입을 알 수 없어 아래서 에러로 인식... 그래서 더미로 에러 제거해줌.
  if (parametersObject && typeof parametersObject === "object") {
    return new URLSearchParams(
      Object.fromEntries(Object.entries(obj).filter((v) => v[1]))
    ).toString();
  } else {
    return null;
  }
};
